import { render } from "./InspectionSettings.vue?vue&type=template&id=c305d158"
import script from "./InspectionSettings.vue?vue&type=script&lang=js"
export * from "./InspectionSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__